var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoomSize = function SvgRoomSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.319,
    height: 49.319
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e4dcd3",
    "data-name": "3d-cube-3d-design-3d-shape-cube-geometric-geometry-2-svgrepo-com"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.277.339A.55.55 0 0 0 48.771 0H13.7a.55.55 0 0 0-.388.161L.16 13.312A.55.55 0 0 0 0 13.7v35.071a.55.55 0 0 0 .548.548h35.077a.55.55 0 0 0 .382-.159l13.151-13.153a.56.56 0 0 0 .161-.387V.548a.6.6 0 0 0-.042-.209M13.19 1.833a.545.545 0 0 0 1.058-.189V1.1h33.2L35.392 13.152H1.871ZM1.808 48.223a.548.548 0 0 0-.708-.713V14.248h12.052v.552a.55.55 0 1 0 1.1 0v-.548h20.819v20.819h-.548a.55.55 0 1 0 0 1.1h.548v12.052Zm34.359-34.3L48.223 1.871v33.2h-.548a.545.545 0 0 0-.189 1.058L36.167 47.448Z",
    "data-name": "Path 21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 30.687a.55.55 0 0 0-.548.548v1.1a.55.55 0 0 0 1.1 0v-1.1a.55.55 0 0 0-.552-.548",
    "data-name": "Path 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 26.303a.55.55 0 0 0-.548.548v1.1a.55.55 0 1 0 1.1 0v-1.1a.55.55 0 0 0-.552-.548",
    "data-name": "Path 23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 6.576a.55.55 0 0 0 .548-.548v-1.1a.55.55 0 0 0-1.1 0v1.1a.55.55 0 0 0 .552.548",
    "data-name": "Path 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 21.919a.55.55 0 0 0-.548.548v1.1a.55.55 0 1 0 1.1 0v-1.1a.55.55 0 0 0-.552-.548",
    "data-name": "Path 25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.252 10.412v-1.1a.55.55 0 0 0-1.1 0v1.1a.55.55 0 0 0 1.1 0",
    "data-name": "Path 26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 17.536a.55.55 0 0 0-.548.548v1.1a.55.55 0 1 0 1.1 0v-1.1a.55.55 0 0 0-.552-.548",
    "data-name": "Path 27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.851 35.071h-1.1a.55.55 0 1 0 0 1.1h1.1a.55.55 0 1 0 0-1.1",
    "data-name": "Path 28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.235 35.071h-1.1a.55.55 0 1 0 0 1.1h1.1a.55.55 0 1 0 0-1.1",
    "data-name": "Path 29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.003 35.071h-1.1a.55.55 0 0 0 0 1.1h1.1a.55.55 0 1 0 0-1.1",
    "data-name": "Path 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.387 35.071h-1.1a.55.55 0 1 0 0 1.1h1.1a.55.55 0 1 0 0-1.1",
    "data-name": "Path 31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.468 35.071h-1.1a.55.55 0 1 0 0 1.1h1.1a.55.55 0 1 0 0-1.1",
    "data-name": "Path 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.084 35.071h-1.1a.55.55 0 1 0 0 1.1h1.1a.55.55 0 1 0 0-1.1",
    "data-name": "Path 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.205 35.41a.548.548 0 0 0-.891-.179l-.775.775a.548.548 0 1 0 .775.775l.775-.775a.55.55 0 0 0 .116-.596",
    "data-name": "Path 34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.212 38.331-.775.775a.548.548 0 1 0 .775.775l.775-.775a.548.548 0 1 0-.775-.775",
    "data-name": "Path 35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.112 41.431-.775.775a.548.548 0 0 0 .775.775l.775-.775a.548.548 0 0 0-.775-.775",
    "data-name": "Path 36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.013 44.531-.775.775a.548.548 0 1 0 .775.775l.775-.775a.548.548 0 1 0-.775-.775",
    "data-name": "Path 37"
  }))));
};
export default SvgRoomSize;